import React from 'react'

import { UseFormReturn } from 'react-hook-form'

import { FormField } from '@/components/ui/form'

import { CountryDropdown } from '../ui-custom/country-dropdown'
import { FormFieldWrapper } from './FormFieldWrapper'

interface CountryFieldProps {
  form: UseFormReturn<any>
  name: string
  label: string
  placeholder?: string
  tooltip?: string
  desc?: string
  disabled?: boolean
  required?: boolean
  locale?: string
  onlyCountries?: string[]
  preferredCountries?: string[]
  className?: string
}

export function CountryField({
  form,
  name,
  label,
  placeholder = 'Select country',
  tooltip,
  desc,
  disabled,
  required = false,
  locale = 'en',
  onlyCountries = ['KW'],
  preferredCountries = ['KW'],
  className,
}: CountryFieldProps) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormFieldWrapper label={label} tooltip={tooltip} desc={desc} required={required}>
          <CountryDropdown
            value={field.value}
            onChange={(country) => {
              field.onChange(country.alpha2)
            }}
            placeholder={placeholder}
            locale={locale}
            onlyCountries={onlyCountries}
            preferredCountries={preferredCountries}
            defaultValue={field.value}
            disabled={disabled}
            className={className}
          />
        </FormFieldWrapper>
      )}
    />
  )
}

export const MemoizedCountryField = React.memo(CountryField) as typeof CountryField
